export default "__VITE_ASSET__DJxTfszB__"